import { Position } from './types';

export const setDialogPosition = ({
    position,
    distance,
    targetRef,
    elementRef,
    containerRef
}: {
    position: Position;
    distance?: number;
    targetRef: React.RefObject<HTMLElement>;
    elementRef: React.RefObject<HTMLElement>;
    containerRef: React.RefObject<HTMLElement>;
}) => {
    if (!targetRef.current || !elementRef.current || !containerRef.current) return;

    const targetRect = targetRef.current.getBoundingClientRect();
    const containerScroll = containerRef.current.scrollTop || 0;
    const distanceWithArrow = 20 + (distance || 0);

    switch (position) {
        case 'top':
            elementRef.current.style.top = `${targetRect.top + containerScroll - distanceWithArrow}px`;
            elementRef.current.style.left = `${targetRect.left + targetRect.width / 2}px`;
            elementRef.current.style.transform = 'translate(-100%, -100%)';
            break;
        case 'bottom':
            elementRef.current.style.top = `${targetRect.bottom + containerScroll + distanceWithArrow}px`;
            elementRef.current.style.left = `${targetRect.left + targetRect.width / 2}px`;
            elementRef.current.style.transform = 'translate(-100%, 0)';
            break;
    }
};
